/**
 * Total monthly cost of a client's subscriptions, in dollars.
 *
 * Uses the matching price from the active-prices list when there is one, and
 * otherwise falls back to the price stored on the subscription itself. The
 * fallback matters for archived Stripe prices: they drop out of the active
 * list but existing subscribers keep paying them.
 */
export const getMonthlyCost = (userSubs = [], prices = []) =>
	userSubs.reduce((total, sub) => {
		const subPrice = sub.items?.data?.[0]?.price;
		const price = prices?.find((p) => p.id === subPrice?.id);
		const unitAmount = price ? price.unit_amount : subPrice?.unit_amount;
		return total + (unitAmount || 0) / 100;
	}, 0);
